import {NodeType} from 'common/src/modules/nodes/nodes.types';

function isCreativeTypeNode(nodeType: NodeType) {
  return [
    NodeType.CREATIVE,
    NodeType.NATIVE_CREATIVE,
    NodeType.SOCIAL_FACEBOOK_AD_CREATIVE,
    NodeType.SOCIAL_TIKTOK_AD_CREATIVE,
    NodeType.SOCIAL_YOUTUBE_AD_CREATIVE,
    NodeType.SOCIAL_YOUTUBE_DV360_AD_CREATIVE,
    NodeType.SOCIAL_SNAPCHAT_AD_CREATIVE,
    NodeType.SOCIAL_SNAPCHAT_DPA_CREATIVE,
    NodeType.FACEBOOK_CAROUSEL_CREATIVE,
    NodeType.SOCIAL_LINKEDIN_AD_CREATIVE,
    NodeType.FACEBOOK_DPA_CAROUSEL_CREATIVE,
    NodeType.FACEBOOK_DPA_CREATIVE,
    NodeType.CONCEPT_CREATIVE,
  ].includes(nodeType);
}

export default isCreativeTypeNode;
